module.exports = __webpack_public_path__ + "img/rekam_jejak.fb355e68.png";